<input
  #fileInput
  class="upload-input"
  type="file"
  accept=".pdf,.jpg,.jpeg,.png"
  [multiple]="multiple()"
  (change)="onFileSelected($event)"
/>

<div
  class="upload-dropzone"
  [class.upload-dropzone--dragging]="dragging()"
  (dragover)="dragOver($event)"
  (dragleave)="dragging.set(false)"
  (drop)="drop($event)"
>
  <i class="fa-regular fa-arrow-up-from-bracket upload-icon" aria-hidden="true"></i>
  <span class="body-large">{{ multiple() ? 'Allega documenti' : 'Allega documento' }}</span>
  <span class="body-medium">PDF, JPG o PNG (max 10MB)</span>
  <button matButton type="button" (click)="fileInput.click()">Sfoglia file</button>
</div>

@for (file of files(); track $index) {
  <div class="upload-file" role="status">
    <span class="body-medium">{{ file.name }}</span>
    <button matIconButton type="button" aria-label="Rimuovi allegato" (click)="remove($index)">
      <i class="fa-regular fa-xmark" aria-hidden="true"></i>
    </button>
  </div>
}
